import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface PageHeaderContextType {
    title: string | null;
    navigationItems: ReactNode | null;
    setPageHeader: (title: string | null, navigationItems?: ReactNode | null) => void;
}

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined);

export function PageHeaderProvider({ children }: { children: ReactNode }) {
    const [title, setTitle] = useState<string | null>(null);
    const [navigationItems, setNavigationItems] = useState<ReactNode | null>(null);

    const setPageHeader = useCallback((newTitle: string | null, newNavigationItems: ReactNode | null = null) => {
        setTitle(newTitle);
        setNavigationItems(newNavigationItems);
    }, []);

    return (
        <PageHeaderContext.Provider value={{ title, navigationItems, setPageHeader }}>
            {children}
        </PageHeaderContext.Provider>
    );
}

export function usePageHeader() {
    const context = useContext(PageHeaderContext);
    if (!context) {
        throw new Error('usePageHeader must be used within a PageHeaderProvider');
    }
    return context;
}